import React from "react";
import { connect } from "react-redux";
import Modal from "../generalcomponets/modal-mobile";
import { movil } from '../app-movil'
// import { userRecordConstructor } from "firebase-functions/lib/providers/auth";

const mapState = (state) => {
	return {
		familiar : state.af.familiar,
		paso: state.af.pasoInvitado,
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		},
		addEvento: (evento) => {
			dispatch({ "type": "AF_SET_EVENT", "evento": evento});
    }
	};
};

class InvitacionEnviada extends React.Component {

  constructor(props) {
    super(props);
  }

  /*state = {
    isModalOpened: true
  }*/

  componentWillReceiveProps = () => {
    this.setState({ isModalOpened: true });
  }

	close = () => {
    this.props.addEvento("BtnAceptar-InvitacionEnviada");
    this.props.pasoInvitado(0);
    let mensaje = {"return": "home"};
		movil("", mensaje);
    this.setState({ isModalOpened: false });
    this.props.handler.bind(this);
	}

  /*closeModalFromChild = (e) => {
    if(e.target.id == "modalEnviado") {
      this.props.pasoInvitado(0);
      this.setState({ isModalOpened: false});
    }
  }*/

	render() {
		return (
      /*<div>
        {this.state.isModalOpened &&*/
          <div id="modalEnviado" className="GNP-modal" onClick={this.props.handler.bind(this)}>
            <div className="GNP-modal-content">
              <div className="GNP-modal-body">
                <div className="text-center mt-38">
                  <img src={ require("../img/verified_user_success.svg") }/>
                </div>
                <h5 className="title-mail">Invitación enviada</h5>
                <span className="text-access">
                  {`¡Listo! tu invitación ha sido enviada a ${this.props.familiar.email}, en breve recibirá un correo para poder visualizar tus pólizas. Podrás agregar y eliminar invitados cuándo lo desees.`}
                </span>
                <div className="text-center aceptar-cancelar-btn mt-38 mb-20">
                  <a id="modalEnviado" onClick={this.close.bind(this)} className="orange-movil">Aceptar</a>
                </div>
              </div>
            </div>
          </div>
        /*}
      </div>*/
		);
	}
}

export default connect(mapState, mapDispatch)(InvitacionEnviada);



// WEBPACK FOOTER //
// ./src/acceso-familiar/InvitacionEnviadaMovil.cmpt.js